<template>
  <div style="padding-left: 10px;height: 100% ">
    <div style="margin: 10px 0 0 8px">
      <el-form inline>
        <el-form-item label-width="50px" >
          <el-select v-model.trim="brand_id" placeholder="请输入品牌" clearable class="input" @Change="changeCatalogByBrand(brand_id)">
            <el-option  v-for="item in brandList" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label-width="50px" >
          <el-select v-model.trim="catalog_id" placeholder="请输入品类" clearable class="input">
            <el-option  v-for="item in catalogList" :key="item.id" :label="item.catalog_name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-input v-model.trim="order_no" placeholder="请输入工单号" clearable class="input"/>
        </el-form-item>
        <el-form-item>
          <el-button @click="search" type="primary" style="margin-left: 15px">查询</el-button>
        </el-form-item>
      </el-form>
      <el-table :data="oowList" stripe fit size="default" style="width: 100%">
        <el-table-column prop="business_unit_name" label="服务中心" width="200"  />
        <el-table-column prop="brand_name" label="品牌" width="180" />
        <el-table-column prop="catalog_name" label="品类" width="180" />
        <el-table-column prop="order_no" label="工单号"  width="200"/>
        <el-table-column prop="unit_price" label="单价" width="100"/>
        <el-table-column prop="discount_price" label="折扣价" width="100"/>
        <el-table-column prop="customer_phone" label="客户电话" width="150"/>
        <el-table-column prop="quote_state" label="报价说明" width="250"/>
        <el-table-column prop="service_user_name" label="客服人员" width="150" v-if="componentParam !== 'oow_service_task'"/>
        <el-table-column fixed="right" label="操作" min-width="100" >
          <template #default="scope" >
            <FrameButton :key="scope.row.id" :button="busButton" :parentData="scope.row"/>
          </template>
        </el-table-column>
      </el-table>
      <!----------------分页----------------->
      <div class="pagination">
        <el-pagination background layout=" sizes, total, prev, pager, next"
                       :page-sizes="[1,5,10,15,20]"
                       v-model:current-page="currentPage"
                       v-model:page-size="pageSize"
                       v-model:total="this.oowTotal"
                       @size-change="handleSizeChange"
                       @current-change="handleCurrentChange"/>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "StationParent",
  components: {},
  props: {
    componentParam: {
      type: String,
      required: true
    },
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  data() {
    return {
      currentPage: 1,//当前页数
      pageSize: 10,//当前页的数量
      oowTotal:0,//查询的总数

      brand_id:'',
      catalog_id:'',
      order_no:'',
      brandList:[],
      catalogList:[],
      oowList:[],
      busButton:{},
    }
  },
  computed: {
    stationId() {
      if (this.componentParam && this.componentParam.length > 4) {
        return this.componentParam.substring(4);
      }
      return '';
    },
  },
  provide() {
    return {
      $fn: {
        refreshTable:()=>{
          this.search()
        },
      }
    }
  },
  created() {
    this.getBrandList()
    this.search()
    this.getOowButton()
  },
  methods: {

    //获取品牌
    async getBrandList(){
      this.brandList = await this.$http('repairDsService.getAllBrand')
    },
    //根据品牌获取品类
    async changeCatalogByBrand(brandId){
      this.catalogList = await this.$http('repairCatalogService.getCatalogList', {brand_id: brandId})
    },

    //分页数据,控制当前页有多少条
    handleSizeChange(val) {
      console.log("val-=",val)
      this.pageSize = val
      this.search();
    },

    //控制当前是多少页
    handleCurrentChange(val) {
      console.log("val2-=", val)
      this.currentPage = val
      this.search();
    },

    async getOowButton(){
      this.busButton = await this.$http('oowItemService.getOowButton', {component_param: this.componentParam})
    },

    async search() {
      let params = {
        brand_id: this.brand_id,
        catalog_id: this.catalog_id,
        order_no:this.order_no,
        component_param:this.componentParam,
        current_page: this.currentPage,
        page_size: this.pageSize
      }
      let result = await this.$http('oowItemService.search', params)
      this.oowList = result.resultList
      this.oowTotal = result.oowTotal
    },


  }
}
</script>

<style scoped>
.input {
  height: 32px;
  width: 250px;
  margin-right: 10px;
}

/*分页样式*/
.pagination{
  display: flex;
  justify-content: flex-end;
  margin-top: 5px;
  padding: 0 5px 5px 0;
}

.el-table {
  width: 100%;
}

:deep(.el-table .cell){
  line-height: 30px
}

.el-table :deep(.el-table__header .cell) {
  word-break: break-word;
}
:deep(.el-table .cell.el-tooltip ) {
  max-width: 50px;
  white-space: nowrap;
}

.link-window :deep(.el-button.is-link) {
  padding: 0;
}


.search-box {
  padding-top: 10px;
  line-height: 40px;
  min-height: 50px;
}

.item-text {
  text-align: right;
}

.login-user {
  position: absolute;
  right: 10px;
}
</style>